export const PHOTO_SHARE_LIMIT_HEADLINE =
  "You've shared all your photos for this one 📸";

export const PHOTO_SHARE_LIMIT_THANKS = 'Thanks for adding to the wall!';
